<amplify-authenticator>
  @if (authLoadingVisible() && authenticator.authStatus !== 'authenticated') {
    <div class="fixed inset-0 z-40 flex items-center justify-center bg-slate-900/20 p-4">
      <div class="flex items-center gap-3 rounded-lg bg-white px-4 py-3 text-sm text-slate-700 shadow">
        <span class="material-icons animate-spin text-slate-500">autorenew</span>
        Loading sign-in…
      </div>
    </div>
  }
  @if (authFallbackVisible() && authenticator.authStatus !== 'authenticated') {
    <div class="fixed inset-0 z-40 flex items-center justify-center bg-slate-900/30 p-4">
      <div class="w-full max-w-md rounded-lg bg-white p-6 shadow-lg">
        <h2 class="text-lg font-semibold text-slate-900">Auth screen not loading</h2>
        <p class="mt-2 text-sm text-slate-600">
          @if (authErrorMessage()) {
            {{ authErrorMessage() }}
          } @else {
            If the login UI is blank, try resetting the local auth cache.
          }
        </p>
        <div class="mt-6 flex justify-end gap-3">
          <button
            class="rounded-md border border-slate-200 px-4 py-2 text-sm text-slate-700 hover:bg-slate-50"
            (click)="signIn()"
          >
            Try Sign In
          </button>
          <button
            class="rounded-md border border-slate-200 px-4 py-2 text-sm text-slate-700 hover:bg-slate-50"
            (click)="resetAuth()"
          >
            Reset Auth
          </button>
        </div>
      </div>
    </div>
  }
  <ng-template amplifySlot="authenticated">
    <div class="min-h-screen bg-slate-100 text-slate-900">
      <header class="flex items-center justify-between border-b border-slate-200 bg-white px-6 py-4 shadow-sm">
        <div class="flex items-center gap-3">
          <div class="flex h-9 w-9 items-center justify-center rounded-lg bg-slate-900 text-sm font-semibold text-white">
            ILTY
          </div>
          <div>
            <p class="text-xs font-semibold uppercase tracking-[0.2em] text-slate-400">Admin Console</p>
            <h1 class="text-lg font-semibold text-slate-900">I Leave To You</h1>
          </div>
        </div>
        <button
          class="rounded-md border border-slate-200 px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50"
          (click)="signOut()"
        >
          Sign Out
        </button>
      </header>
      <div class="flex">
        <aside class="min-h-[calc(100vh-73px)] w-64 border-r border-slate-200 bg-white p-5">
          <nav class="mt-4 space-y-2 text-sm font-medium text-slate-700">
            <a
              class="flex items-center gap-3 rounded-lg px-3 py-2 transition hover:bg-slate-100"
              routerLink="/accounts"
              routerLinkActive="bg-slate-900 text-white hover:bg-slate-900"
            >
              <span class="material-icons text-base">group</span>
              Accounts
            </a>
            <a
              class="flex items-center gap-3 rounded-lg px-3 py-2 transition hover:bg-slate-100"
              routerLink="/customers"
              routerLinkActive="bg-slate-900 text-white hover:bg-slate-900"
            >
              <span class="material-icons text-base">auto_awesome</span>
              Customers
            </a>
          </nav>
        </aside>
        <main class="flex-1 p-6">
          <router-outlet />
        </main>
      </div>
    </div>
  </ng-template>
</amplify-authenticator>
